import { render, staticRenderFns } from "./property-list-page.vue?vue&type=template&id=71348488&scoped=true&"
import script from "./property-list-page.vue?vue&type=script&lang=js&"
export * from "./property-list-page.vue?vue&type=script&lang=js&"
import style0 from "./property-list-page.vue?vue&type=style&index=0&id=71348488&lang=scss&scoped=true&"
import style1 from "./property-list-page.vue?vue&type=style&index=1&id=71348488&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71348488",
  null
  
)

export default component.exports
import {QBreadcrumbs,QIcon,QBreadcrumbsEl,QCard} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QIcon,QBreadcrumbsEl,QCard})
